<template>
  <div class="card executive-card mb-4">
    <div class="card-body py-3">
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
        <div class="d-flex flex-wrap align-items-center gap-2 flex-grow-1">
          <div class="filter-item">
            <label class="filter-label">Estado</label>
            <b-form-select
              class="exec-select"
              :value="filters.state"
              :options="stateOptions"
              size="sm"
              @input="updateFilter('state', $event)"
            />
          </div>
          <div class="filter-item">
            <label class="filter-label">Cultura</label>
            <b-form-select
              class="exec-select"
              :value="filters.culture"
              :options="cultureOptions"
              size="sm"
              @input="updateFilter('culture', $event)"
            />
          </div>
          <div class="filter-item">
            <label class="filter-label">Tecnico</label>
            <b-form-select
              class="exec-select"
              :value="filters.technician"
              :options="technicianOptions"
              size="sm"
              @input="updateFilter('technician', $event)"
            />
          </div>
          <div class="filter-item">
            <label class="filter-label">Periodo</label>
            <b-form-select
              class="exec-select"
              :value="filters.period"
              :options="periodOptions"
              size="sm"
              @input="updateFilter('period', $event)"
            />
          </div>
        </div>

        <div class="d-flex align-items-center gap-1">
          <b-button size="sm" class="btn-exec-primary" @click="$emit('view-map')">
            Visualizar Mapa Completo
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExecutiveFiltersBar',
  props: {
    filters: {
      type: Object,
      required: true,
    },
    stateOptions: {
      type: Array,
      default: () => [],
    },
    cultureOptions: {
      type: Array,
      default: () => [],
    },
    technicianOptions: {
      type: Array,
      default: () => [],
    },
    periodOptions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    updateFilter(key, value) {
      this.$emit('update:filters', { ...this.filters, [key]: value })
    },
  },
}
</script>

<style scoped>
.executive-card {
  border: 1px solid #d2e0e9;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(10, 34, 64, 0.08);
  background: linear-gradient(160deg, #ffffff 0%, #f6fbff 100%);
}

.filters-header {
  margin-bottom: 10px;
}

.filters-title {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  color: #47637a;
  font-weight: 700;
}

.filter-item {
  min-width: 170px;
}

.filter-label {
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  color: #36586f;
  font-weight: 700;
  text-transform: uppercase;
}

.exec-select {
  border-radius: 10px;
  border: 1px solid #cfdce6;
  background-color: #fbfeff;
  color: #16354b;
  font-weight: 600;
}

.exec-select:focus {
  border-color: #278f63;
  box-shadow: 0 0 0 0.18rem rgba(39, 143, 99, 0.14);
}

.btn-exec-primary {
  border: 0;
  border-radius: 10px;
  padding: 0.45rem 0.8rem;
  background: linear-gradient(135deg, #1a8f5b 0%, #0d5f79 100%);
  color: #fff;
  font-weight: 700;
}

.btn-exec-primary:hover {
  color: #fff;
  filter: brightness(1.04);
}

.btn-exec-outline {
  border-radius: 10px;
  padding: 0.45rem 0.8rem;
  border: 1px solid #9bb8cc;
  color: #194865;
  font-weight: 700;
  background: #fff;
}

.btn-exec-outline:hover {
  border-color: #0d607c;
  color: #0d607c;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}
</style>
